import { WHATS_APP_ORIGIN } from './constants';
import type { CreateShareLinkUrl } from './types';

export const createShareLinkUrl: CreateShareLinkUrl = ({
  text,
}) => {
  const url = new URL(WHATS_APP_ORIGIN);
  const { searchParams } = url;

  searchParams.set('text', text);

  return url;
};
